module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAlUlEQVQ4y2NgGByg6Nh/GP5zUQwvZpiXgMD4DPh5QZwyAz6el4SzPyOxiTLgximF/1XbbeCaOnZagMWINsBrrdd/tvlx/x+elvv/+Izsf84FsWAxkg24BzUAxCbJAJgXNh3S+b/ygB6YTZIXYAGnsjTsv/TiiP8fzkuREY0XxcEGgDBylBJtAAiDvADCZKUD0lLikAYAqQB7YibuhTUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/VC.png
// module id = 1296
// module chunks = 0